import React from 'react';

import './Magazzino.css';

type ImgProps = {
    src: string;
    alt: string;
    um: string;
    className: string;
};
export default function Img(props: ImgProps) {
    function CheckImage(path) {
        const img = new Image();
        img.src = path;

        if (img.complete) return true;

        return false;
    }

    if (props.src !== '')
        return <img className={props.className} style={{ marginRight: '20px' }} alt={props.alt} src={props.src}></img>;
    else {
        if (props.um === 'TO') {
            return (
                <img
                    className={props.className}
                    style={{ marginRight: '20px' }}
                    alt={props.alt}
                    src="custom/no-imageblocchi_300.png"
                ></img>
            );
        } else {
            return (
                <img
                    className={props.className}
                    style={{ marginRight: '20px' }}
                    alt={props.alt}
                    src="custom/no-imagelastre_300.png"
                ></img>
            );
        }
    }
}
